import { OrganizationInvitationDetailsState } from "@idw-types/state/organization-invitation-details-state";
import { OrganizationInvitationDetailsActionTypes, OrganizationInvitationDetailsActions } from "../actions/organization-invitation-details-actions";

export const initialOrganizationInvitationDetailsState: OrganizationInvitationDetailsState = {
    organizationInvitation: {
        isLoading: false,
        organizationInvitation: null,
    }
};

export const organizationInvitationDetailsReducer = (
    state: OrganizationInvitationDetailsState = initialOrganizationInvitationDetailsState,
    action: OrganizationInvitationDetailsActions
): OrganizationInvitationDetailsState => {
    switch (action.type) {
        // Organization Invitation Details 
        case OrganizationInvitationDetailsActionTypes.SET_ORGANIZATION_INVITATION_DETAILS_LOADING:
            return {
                ...state,
                organizationInvitation: {
                    ...(action.payload.isLoading
                        ? { ...initialOrganizationInvitationDetailsState.organizationInvitation }
                        : { ...state.organizationInvitation }),
                    isLoading: action.payload.isLoading
                }
            };
        case OrganizationInvitationDetailsActionTypes.SET_ORGANIZATION_INVITATION_DETAILS:
            return {
                ...state,
                organizationInvitation: {
                    ...state.organizationInvitation,
                    organizationInvitation: action.payload.axnAdminUserInvitation,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};